import React from 'react';

function RegionResources({ resources }) {
  if (!resources?.length) return null;

  return (
    <ul className="space-y-4">
      {resources.map((resource) => (
        <li
          key={resource.url}
          className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm"
        >
          <a
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg font-semibold text-blue-600 hover:underline"
          >
            {resource.title}
          </a>
          <p className="text-sm text-gray-600 mt-1">{resource.description}</p>
        </li>
      ))}
    </ul>
  );
}

export default RegionResources;
